import styled from 'styled-components'
const Wrapper = styled.div`
.resource-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    cursor : pointer;
}

    .resource-container span{
    color: #1D1D1D;

    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

    .info-box {
        margin: 0 auto;
        padding: 23px 18px;
        max-width: 100%;
        box-shadow: 0 1px 3px #0000000d;
        border-radius: 10px;
        border: 1px solid #D2F1FF;
        background: #fafdff;
        font-size: 16px;
    }
.info-grid{
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    row-gap: 8px;
    column-gap: 40px;
    font-size: 16px;
    color: #000;
    font-weight: 600;
}

@media (min-width: 992px) {
    .info-grid {
        grid-template-columns: repeat(4, 1fr);
        column-gap: 36px;
    }
}

@media (max-width: 768px) {
    .info-grid {
        grid-template-columns: repeat(2, 1fr);
        column-gap: 16px;
    }
}
@media (max-width: 576px) {
    .info-grid[_ngcontent-ng-c2657310264] {
        grid-template-columns: 1fr;
    }
.custom-progress-content {
    width: 82%!important;
}
.progress-message{
    font-size: 0.7rem !important;
}

}

.error-msg {
  color: red;
  font-size: 0.875rem;
}

.btn-grey {
    border-radius: 12px;
    background: #B4B3B4;
    height: 50px;
    padding: 10px 24px;
    justify-content: center;
    gap: 8px;
    align-self: stretch;
    color: white;
    display: flex;
    width: -webkit-fill-available;
    align-items: center;
    font-size: 1.2rem;
}

.btn-blue {
    border-radius: 12px;
    background: #0B3C5D;
    height: 50px;
    padding: 10px 24px;
    justify-content: center;
    gap: 8px;
    align-self: stretch;
    color: white;
    display: flex;
    width: -webkit-fill-available;
    align-items: center;
    font-size: 1.2rem;
}
.preview-area {
  border: 2px dashed #ccc;
  padding: 1rem;
  text-align: center;
  background: #f9f9f9;
  border-radius: 8px;
  min-height : 10rem;
}
video{
    width: 100%;
    height: 411px;
    
}

.processing-card-heading{
    color: #374151;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}
    .icon-big{
    width: 100%;
    height: 411px;}
    .icon-type{
       border: 4px solid #818080;
    padding: 4px;
    font-size: 3rem;
    color: #818080;
    }

    .file-name{
        color: #000;
        text-align: center;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        margin-bottom : 5px;
    }

    .grey-text-file{
        color: #919191;
        text-align: center;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        margin-bottom: 2px;
    }

    .file-detected{
   color: #696769;
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-top: 1rem;
    
    }



    .processing-step {
  margin-bottom: 1.5rem;
}

.step-header {
  display: flex;
      gap: 0.5rem;
  align-items: center;
  font-weight: 500;
  margin-bottom: 0.3rem;
}

.step-header .step-icon {
  font-size: 1.2rem;
  margin-right: 0.5rem;
}

.step-percent {
  font-size: 0.9rem;
  color: #6c757d;
}

.step-status-text {
  font-size: 0.85rem;
  color: #6c757d;
  margin-top: 0.3rem;
}

.progress {
  height: 6px;
  background-color: #e9ecef;
  border-radius: 3px;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  transition: width 0.3s ease;
}

.active .step-header {
  color: #0d6efd;
}
.cus-date {
display :block;
  flex: 1;
  width: 100% !important;
}
.react-datepicker-wrapper{
display :block;

}
.input-group {
    position: relative;
    display: flex
;
    flex-wrap: inherit;
    align-items: stretch;
    width: 100%;
}
.react-datepicker-wrapper{
    width: -webkit-fill-available;
}
.disabled{
    pointer-events: none;
    cursor: not-allowed;
}
    .not-allowed{
    cursor: not-allowed;
    }
.media-details{
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px;
    border-radius: 10px;
    border: 1px solid rgba(0, 126, 17, 0.50);
    background: #EEFFF0;
    margin-top: 2rem;
}




.custom-progress-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5); // darker, richer overlay
    backdrop-filter: blur(6px);     // heavier blur
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
}

.custom-progress-content {
    width: 60%;
    text-align: center;
    padding: 30px 40px;
    background: white;
    border-radius: 16px;
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.2);
    position: relative;
    animation: fadeInUp 0.5s ease-out;
}

@keyframes fadeInUp {
    0% {
        opacity: 0;
        transform: translateY(20px);
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

.processing-text {
    font-size: 20px;
    font-weight: 600;
    margin: 20px 0;
    color: #333;
}

.custom-progress-bar-container {
    width: 100%;
    height: 28px;
    background-color: #e9ecef;
    border-radius: 14px;
    overflow: hidden;
    box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.1);
}

.custom-progress-bar {
    height: 100%;
    color: white;
    text-align: center;
    font-weight: bold;
    line-height: 28px;
    transition: width 0.1s ease-in-out;
    background: linear-gradient(
        90deg,
        #0084ff,
        #2e98ff,
        #0084ff
    );
    background-size: 200% auto;
    animation: shimmer 2s linear infinite;
}

@keyframes shimmer {
    0% {
        background-position: 0% center;
    }
    100% {
        background-position: 200% center;
    }
}
.processing-text {
    font-size: 18px;
    font-weight: 500;
    margin: 20px 0;
    color: #0084FF;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.modern-spinner {
    width: 40px;
    height: 40px;
    border: 4px solid rgba(0, 132, 255, 0.3);
    border-top: 4px solid #0084ff;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin: 0 auto 16px auto;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}



@media (max-width: 768px) {
    .custom-progress-content {
          padding: 10px 10px;
    }
          .processing-status{
            font-size : 1.3rem !important;
          }
            .processing-text{
                  font-size : 14px !important;
            }
        .card-body {
    padding: 10px 10px !important;
}

.custom-progress-bar{

font-size: 13px!important
}
}



video{
        width: 100%;
    height: 20rem;
    // object-fit: inherit;
    display: block;
}
    audio {
        width: -webkit-fill-available;
    }
        .processing-status{
            font-weight : 600;
            font-size : 1.6rem;
        }
.progress-message{
    letter-spacing: 1px;
    font-weight: 500;
    font-size: 0.9rem;
}

.progress-message {
  font-size: 1rem;
  font-weight: 500;
  letter-spacing: 0.5px;
  color: #333;
  text-align: center;
  padding: 4px 8px;
  transition: opacity 0.6s ease, transform 0.6s ease;
  animation: fadeSlide 10s infinite;
}

/* subtle fade + slide effect */
@keyframes fadeSlide {
  0% {
    opacity: 0;
    transform: translateY(8px);
  }
  10%, 90% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(-8px);
  }
}
  
 `
export default Wrapper